var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34392 13.656C1.57984 12.9181 0.970378 12.0353 0.551106 11.0593C0.131834 10.0832 -0.0888561 9.03348 -0.0980866 7.97125C-0.107317 6.90901 0.0950965 5.85558 0.497344 4.87241C0.899591 3.88924 1.49362 2.99602 2.24476 2.24488C2.9959 1.49374 3.88911 0.899713 4.87228 0.497466C5.85546 0.0952185 6.90889 -0.107195 7.97113 -0.0979645C9.03336 -0.088734 10.0831 0.131956 11.0592 0.551228C12.0352 0.9705 12.9179 1.57996 13.6559 2.34404C15.1132 3.85286 15.9195 5.87367 15.9013 7.97125C15.8831 10.0688 15.0417 12.0753 13.5585 13.5586C12.0752 15.0419 10.0687 15.8832 7.97113 15.9014C5.87355 15.9197 3.85273 15.1133 2.34392 13.656ZM12.5279 12.528C13.7288 11.3271 14.4035 9.69837 14.4035 8.00004C14.4035 6.30171 13.7288 4.67294 12.5279 3.47204C11.327 2.27114 9.69825 1.59648 7.99992 1.59648C6.30159 1.59648 4.67282 2.27114 3.47192 3.47204C2.27102 4.67294 1.59636 6.30171 1.59636 8.00004C1.59636 9.69837 2.27102 11.3271 3.47192 12.528C4.67282 13.7289 6.30159 14.4036 7.99992 14.4036C9.69825 14.4036 11.327 13.7289 12.5279 12.528ZM5.59992 4.80004L11.9999 8.00004L5.59992 11.2V4.80004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1e6c74978d3cbc4e37f27b50e9cb4524.svg";
export { ForwardRef as ReactComponent };